// List of all icons that are supported by `Icon`. These map directly
// to the names of `.svg` files. To add an `Icon`, add the `.svg`
// file to the appropriate location and then add the icon to this array.
export const iconNames = {
  actionAttachment: true,
  actionAutoRenew: true,
  actionBookmark: true,
  actionBug: true,
  actionCalendar: true,
  actionCamera: true,
  actionCopy: true,
  actionCopyFill: true,
  actionDrag: true,
  actionEdit: true,
  actionEditCircle: true,
  actionEmail: true,
  actionExplore: true,
  actionFilter: true,
  actionFlag: true,
  actionInsert: true,
  actionLink: true,
  actionLock: true,
  actionPhoto: true,
  actionPlay: true,
  actionSend: true,
  actionShare: true,
  actionTrash: true,
  alertCircle: true,
  alertInfo: true,
  alertNotificationBell: true,
  alertTriangle: true,
  arrowBigDown: true,
  arrowBigLeft: true,
  arrowBigRight: true,
  arrowBigUp: true,
  arrowBranch: true,
  arrowCode: true,
  arrowCodeDots: true,
  arrowConnect: true,
  arrowDropdown: true,
  arrowExit: true,
  arrowLineLeft: true,
  arrowLineRight: true,
  arrowOffsite: true,
  arrowRefresh: true,
  arrowSmallDown: true,
  arrowSmallLeft: true,
  arrowSmallRight: true,
  arrowSmallUp: true,
  arrowZoom: true,
  commentAdd: true,
  commentBlank: true,
  commentConvo: true,
  commentFilled: true,
  commentWaiting: true,
  crosshairs: true,
  fileAdd: true,
  fileFile: true,
  fileFilled: true,
  fileGuide: true,
  formAdd: true,
  formAddCircle: true,
  formAddSquare: true,
  formBlank: true,
  formCheck: true,
  formCheckCircle: true,
  formCheckSquare: true,
  formDash: true,
  formDashCircle: true,
  formDashSquare: true,
  formRadioCheck: true,
  formRadioDot: true,
  formRadioUnchecked: true,
  formX: true,
  formXCircle: true,
  locationOn: true,
  magnifyingGlass: true,
  miscBolt: true,
  miscClock: true,
  miscCloud: true,
  miscColor: true,
  miscCookie: true,
  miscCreditCard: true,
  miscDollar: true,
  miscEye: true,
  miscFingerprint: true,
  miscFire: true,
  miscGraph: true,
  miscGraphBox: true,
  miscHand: true,
  miscHeadset: true,
  miscLearn: true,
  miscList: true,
  miscMic: true,
  miscPie: true,
  miscSecurity: true,
  miscSteps: true,
  miscTimelapse: true,
  miscUptime: true,
  miscWallet: true,
  miscWorld: true,
  navApps: true,
  navBell: true,
  navBlog: true,
  navCog: true,
  navDashboard: true,
  navExplore: true,
  navFolder: true,
  navHelp: true,
  navHome: true,
  navMenu: true,
  navMoreHoriz: true,
  navMoreVert: true,
  navSearch: true,
  personAdd: true,
  personCircle: true,
  personGroup: true,
  personOne: true,
  ratingHappy: true,
  ratingHeart: true,
  ratingNeutral: true,
  ratingSad: true,
  ratingStar: true,
  ratingThumbsBoth: true,
  ratingThumbsDown: true,
  ratingThumbsUp: true,
  ratingVeryHappy: true,
  ratingVerySad: true,
  settingsRemote: true,
  statusFilter: true,
  statusPaused: true,
  statusPlaying: true,
  team: true,
  upAndDownArrows: true,
  x: true,
  zapierLogo: true,
} as const;

type IconsMap = {
  [k: string]: string;
};

export const iconsMap: IconsMap = Object.keys(iconNames).reduce(
  (icons, iconName) => {
    icons[iconName] = `./${iconName}.svg`;
    return icons;
  },
  {} as IconsMap
);

export type IconName = keyof typeof iconNames;
